var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "user-center-slot",
    [
      _c(
        "user-center-container-slot",
        [
          _c("user-center-menu"),
          _vm._v(" "),
          _c(
            "user-center-content-slot",
            { attrs: { hidden: true } },
            [
              _c("user-center-content-title", { attrs: { title: "基本信息" } }),
              _vm._v(" "),
              _c("div", { staticClass: "user-center__info-row" }, [
                _c("div", { staticClass: "user-center__info-portrait" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ]
                    },
                    [
                      _vm.ruleForm.headPictureUrl
                        ? [
                            _c("img", {
                              staticClass: "user-center__info-pic",
                              attrs: {
                                src:
                                  this.$baseURL +
                                  "vul/hsrc/vul/report/servlet/res/image?attachmentId=" +
                                  _vm.ruleForm.headPictureUrl
                              }
                            })
                          ]
                        : [
                            _c("i", {
                              staticClass:
                                "iconfont icon-touxiang user-center__info-pic user-center__info-pic--default"
                            })
                          ]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isEdit,
                          expression: "!isEdit"
                        }
                      ],
                      staticClass: "user-center__info-portrait-upload"
                    },
                    [
                      _c("div", [
                        _c(
                          "div",
                          [
                            _c(
                              "xui-upload",
                              {
                                staticClass: "xui-upload--text",
                                attrs: {
                                  action: _vm.action,
                                  headers: _vm.xCsrfToken,
                                  "on-error": _vm.reportError,
                                  limit: 1,
                                  "before-upload": _vm.beforUploadZip,
                                  "show-overflow-tooltip": "",
                                  "on-exceed": _vm.handleExceed,
                                  "on-success": _vm.handlePreview,
                                  "with-credentials": true
                                }
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _vm.ruleForm.headPictureUrl
                                      ? [
                                          _c("img", {
                                            staticClass:
                                              "user-center__info-pic",
                                            attrs: {
                                              src:
                                                this.$baseURL +
                                                "vul/hsrc/vul/report/servlet/res/image?attachmentId=" +
                                                _vm.ruleForm.headPictureUrl
                                            }
                                          })
                                        ]
                                      : [
                                          _c("i", {
                                            staticClass:
                                              "iconfont icon-touxiang user-center__info-pic user-center__info-pic--default"
                                          })
                                        ]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "user-center__info-button--default"
                                  },
                                  [_vm._v("上传头像")]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "user-center__info-portrait-tips" },
                        [
                          _vm._v(
                            "支持jpg、png、gif、jpeg格式图片，大小不超过2M"
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "user-center__info-portrait-txt",
                      on: { click: _vm.openDialog }
                    },
                    [_vm._v("退出奖励计划")]
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v("\n            贡献值："),
                    _c(
                      "span",
                      { staticClass: "user-center__info-portrait-txt--inner" },
                      [_vm._v(_vm._s(_vm.ruleForm.donate))]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editFlag,
                          expression: "editFlag"
                        }
                      ],
                      staticClass: "user-center__info-button--primary",
                      attrs: { href: "javascript:void(0);" },
                      on: { click: _vm.onEdit }
                    },
                    [_vm._v("修改资料")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ]
                },
                [
                  _c("div", { staticClass: "user-center__info-list" }, [
                    _c(
                      "div",
                      {
                        staticClass: "user-center__info-item is-overflow-hidden"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("昵称：")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "user-center__info-item-content is-overflow-hidden"
                          },
                          [_vm._v(_vm._s(_vm.ruleForm.displayName))]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "user-center__info-item is-overflow-hidden"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("签名：")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "user-center__info-item-content is-overflow-hidden"
                          },
                          [_vm._v(_vm._s(_vm.ruleForm.signature))]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "user-center__info-item is-overflow-hidden"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("团队：")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "user-center__info-item-content is-overflow-hidden"
                          },
                          [_vm._v(_vm._s(_vm.ruleForm.team))]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "user-center__info-item is-overflow-hidden"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("主页：")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "user-center__info-item-content is-overflow-hidden"
                          },
                          [_vm._v(_vm._s(_vm.ruleForm.homePage))]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "user-center__info-item is-overflow-hidden"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("邮箱：")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "user-center__info-item-content is-overflow-hidden"
                          },
                          [_vm._v(_vm._s(_vm.ruleForm.email))]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "user-center__info-item is-overflow-hidden"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("QQ/微信：")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "user-center__info-item-content is-overflow-hidden"
                          },
                          [_vm._v(_vm._s(_vm.ruleForm.qq))]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "user-center__info-item is-overflow-hidden"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("邮寄地址：")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "user-center__info-item-content is-overflow-hidden"
                          },
                          [_vm._v(_vm._s(_vm.ruleForm.mailingAddress))]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "user-center__info-item is-overflow-hidden"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("英雄榜展示：")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "user-center__info-item-content is-overflow-hidden"
                          },
                          [
                            [
                              _vm.ruleForm.showRanking == "1"
                                ? _c("span", [_vm._v("参与")])
                                : _c("span", [_vm._v("不参与")])
                            ]
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "user-center__info-item is-overflow-hidden"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("个人资质附件：")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  null != _vm.ruleForm.qualiAttachId &&
                                  "" !== _vm.ruleForm.qualiAttachId,
                                expression:
                                  "null != ruleForm.qualiAttachId && '' !== ruleForm.qualiAttachId"
                              }
                            ],
                            staticClass:
                              "user-center__info-item-content is-overflow-hidden"
                          },
                          [
                            _c("span", [
                              _c("i", { staticClass: "fa fa-file" })
                            ]),
                            _vm._v(" "),
                            _c(
                              "xui-link",
                              {
                                key: _vm.index,
                                staticClass: "attachment_uploadFile_xui-link",
                                attrs: {
                                  href: _vm.url2,
                                  disabled: !_vm.disabledFlag,
                                  type: "primary",
                                  title: _vm.ruleForm.docName,
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.docNameHandle(_vm.ruleForm.docName)
                                    ) +
                                    " \n                  "
                                ),
                                _vm.uploadMsg2 == "您上传的文件正在扫描中..."
                                  ? _c("span", { staticClass: "upload-msg" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.uploadMsg2) +
                                          "\n                  "
                                      )
                                    ])
                                  : _vm.uploadMsg2 !=
                                    "您上传的文件正在扫描中..."
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.uploadMsg2) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isEdit,
                      expression: "!isEdit"
                    }
                  ]
                },
                [
                  _c(
                    "xui-form",
                    {
                      ref: "ruleForm",
                      staticClass: "user-center__info-list",
                      attrs: { model: _vm.ruleForm, rules: _vm.rules }
                    },
                    [
                      _c("div", { staticClass: "user-center__info-item" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "user-center__info-item-title is-required"
                          },
                          [_vm._v("昵称:")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-content" },
                          [
                            _c(
                              "xui-form-item",
                              {
                                staticClass: "is-success",
                                attrs: { prop: "displayName" }
                              },
                              [
                                _c("xui-input", {
                                  attrs: { placeholder: "请输入您的昵称" },
                                  model: {
                                    value: _vm.ruleForm.displayName,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "displayName",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "ruleForm.displayName"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-center__info-item" }, [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("签名:")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-content" },
                          [
                            _c(
                              "xui-form-item",
                              {
                                staticClass: "is-success",
                                attrs: { prop: "signature" }
                              },
                              [
                                _c("xui-input", {
                                  attrs: { placeholder: "请输入您的个性签名" },
                                  model: {
                                    value: _vm.ruleForm.signature,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "signature",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "ruleForm.signature"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-center__info-item" }, [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("团队:")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-content" },
                          [
                            _c(
                              "xui-form-item",
                              {
                                staticClass: "is-success",
                                attrs: { prop: "team" }
                              },
                              [
                                _c("xui-input", {
                                  attrs: {
                                    disabled: true,
                                    placeholder: "请输入您的团队名称"
                                  },
                                  model: {
                                    value: _vm.ruleForm.team,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "team",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "ruleForm.team"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-center__info-item" }, [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("主页:")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-content" },
                          [
                            _c(
                              "xui-form-item",
                              {
                                staticClass: "is-success",
                                attrs: { prop: "homePage" }
                              },
                              [
                                _c("xui-input", {
                                  attrs: {
                                    maxlength: 128,
                                    placeholder: "请输入您的主页地址"
                                  },
                                  model: {
                                    value: _vm.ruleForm.homePage,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "homePage",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "ruleForm.homePage"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-center__info-item" }, [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("邮箱:")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-content" },
                          [
                            _c(
                              "xui-form-item",
                              {
                                staticClass: "is-success",
                                attrs: { prop: "email" }
                              },
                              [
                                _c("xui-input", {
                                  attrs: {
                                    type: "email",
                                    placeholder: "请输入您的邮箱"
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.email = _vm.emailCheck(_vm.email)
                                    }
                                  },
                                  model: {
                                    value: _vm.ruleForm.email,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "email",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "ruleForm.email"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-center__info-item" }, [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("QQ/微信:")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-content" },
                          [
                            _c(
                              "xui-form-item",
                              {
                                staticClass: "is-success",
                                attrs: { prop: "qq" }
                              },
                              [
                                _c("xui-input", {
                                  attrs: { placeholder: "请输入您的QQ账号" },
                                  model: {
                                    value: _vm.ruleForm.qq,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "qq",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "ruleForm.qq"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-center__info-item" }, [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("邮寄地址:")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-content" },
                          [
                            _c(
                              "xui-form-item",
                              {
                                staticClass: "is-success",
                                attrs: { prop: "mailingAddress" }
                              },
                              [
                                _c("xui-input", {
                                  attrs: {
                                    maxlength: 1000,
                                    placeholder: "请输入您的邮寄地址"
                                  },
                                  model: {
                                    value: _vm.ruleForm.mailingAddress,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "mailingAddress",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "ruleForm.mailingAddress"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-center__info-item" }, [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("英雄榜展示:")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-content" },
                          [
                            _c(
                              "xui-select",
                              {
                                attrs: { placeholder: "请选择" },
                                model: {
                                  value: _vm.ruleForm.showRanking,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ruleForm, "showRanking", $$v)
                                  },
                                  expression: "ruleForm.showRanking"
                                }
                              },
                              _vm._l(_vm.options2, function(item) {
                                return _c("xui-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-center__info-item" }, [
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-title" },
                          [_vm._v("个人资质附件:")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "user-center__info-item-content" },
                          [
                            _c(
                              "xui-form-item",
                              {
                                staticClass: "is-success",
                                attrs: { prop: "docName" }
                              },
                              [
                                _c(
                                  "xui-upload",
                                  {
                                    staticClass:
                                      "upload_width report__form-upload",
                                    attrs: {
                                      action: _vm.actionZip,
                                      headers: _vm.xCsrfToken,
                                      "file-list": _vm.fileData,
                                      limit: 1,
                                      "on-error": _vm.reportError,
                                      "on-remove": _vm.resetFile,
                                      "show-overflow-tooltip": "",
                                      accept:
                                        ".doc, .docx, .xlsx,.jpg, .jpeg, .png, .gif,.bmp,.txt,.7z,.rar,.zip,.pdf",
                                      "before-upload": _vm.beforUploadFile,
                                      "on-exceed": _vm.handleExceed,
                                      "on-success": _vm.handlePreviewZip,
                                      "with-credentials": true
                                    }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "report__form-button--upload",
                                        attrs: {
                                          id: "uploadZip",
                                          href: "javascript:void(0);"
                                        }
                                      },
                                      [_vm._v("选择文件")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "user-center__info-item-tips",
                                        attrs: { slot: "tip" },
                                        slot: "tip"
                                      },
                                      [
                                        _vm._v(
                                          "\n                      格式限制:doc, docx, xlsx,jpg, jpeg, png, gif,bmp,txt,7z,rar,zip,pdf格式,不超过10M。 "
                                        ),
                                        this.uploadMsg ==
                                        "您上传的文件正在扫描中..."
                                          ? _c(
                                              "span",
                                              { staticClass: "upload-msg" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.uploadMsg) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : this.uploadMsg !=
                                            "您上传的文件正在扫描中..."
                                          ? _c(
                                              "span",
                                              { staticStyle: { color: "red" } },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.uploadMsg) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "user-center__info-submit" },
                    [
                      _c(
                        "xui-button",
                        {
                          staticClass: "user-center__info-button--bottom",
                          attrs: {
                            type: "primary",
                            disabled: _vm.submitDisabled
                          },
                          on: {
                            click: function($event) {
                              return _vm.onSubmit("ruleForm")
                            }
                          }
                        },
                        [_c("span", [_vm._v(" 提交 ")])]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "xui-dialog",
        {
          attrs: {
            title: "",
            "close-on-click-modal": false,
            showcenter: "",
            visible: _vm.delWarnning,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.delWarnning = $event
            }
          }
        },
        [
          _c("p", { staticClass: "dialog-content" }, [
            _c(
              "span",
              [
                _vm.success
                  ? [
                      _c("img", {
                        staticClass: "img-status",
                        attrs: {
                          src: require("../../../images/settingSuccess.jpg")
                        }
                      })
                    ]
                  : [
                      _c("img", {
                        staticClass: "img-status",
                        attrs: {
                          src: require("../../../images/settingError.png")
                        }
                      })
                    ]
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "dialog-content" }, [
            _c("span", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.success
                      ? "您的个人资料保存成功！"
                      : "您的个人资料保存失败！！"
                  ) +
                  "\n      "
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "xui-dialog",
        {
          staticClass: "warnning-wrap",
          attrs: {
            title: "",
            "close-on-click-modal": false,
            showcenter: "",
            visible: _vm.dialogVisible,
            width: _vm.$store.state.isMobile ? "80%" : "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "h3",
            {
              style: {
                "font-size": _vm.$store.state.isMobile ? "24px" : "16.5px"
              }
            },
            [_vm._v("荣耀安全应急响应中心服务条款")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-wrap",
              style: {
                "font-size": _vm.$store.state.isMobile ? "22px" : "14px"
              }
            },
            [
              _c("p", [
                _vm._v(
                  "欢迎您使用荣耀安全应急响应中心（Honor Security Response Center）服务，本平台在特定场景下需收集您的如下信息:"
                )
              ]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [_vm._v("真实姓名，身份证正反面照片及身份证号；")]),
                _vm._v(" "),
                _c("li", [_vm._v("银行卡号，开户行信息，银行名称；")]),
                _vm._v(" "),
                _c("li", [_vm._v("手机号码，邮寄地址；")]),
                _vm._v(" "),
                _c("li", [_vm._v("昵称，头像，邮箱，主页；")]),
                _vm._v(" "),
                _c("li", [_vm._v("QQ，微信，签名，团队；")]),
                _vm._v(" "),
                _c("li", [_vm._v("IP地址；")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "为防止欺骗行为，荣耀需采集浏览器信息（类型、时区、插件、语言、字体、canvas图片渲染哈希值、webgl图片渲染哈希值）；"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "上述数据将会传输并保存至位于中华人民共和国境内的服务器。"
                )
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v("点击“同意”，即表示您同意\n        "),
                _c(
                  "a",
                  {
                    staticClass: "honor-security-user-protocol",
                    attrs: { href: _vm.safetyURL, target: "_blank" }
                  },
                  [_vm._v("荣耀安全应急响应中心用户协议")]
                ),
                _vm._v("\n        ，并知悉\n        "),
                _c(
                  "a",
                  {
                    staticClass: "honor-security-secret-statement",
                    attrs: { href: _vm.privacyURL, target: "_blank" }
                  },
                  [_vm._v("关于安全应急响应中心与隐私的声明")]
                ),
                _vm._v("。")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", center: "" },
              slot: "footer"
            },
            [
              _c(
                "xui-button",
                { attrs: { size: "bigger" }, on: { click: _vm.handleClose } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "xui-button",
                {
                  attrs: { type: "primary", size: "bigger" },
                  on: { click: _vm.confirm }
                },
                [_vm._v("同意")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.cancelDialog
        ? _c(
            "xui-dialog",
            {
              staticClass: "login-dialog-cancel",
              attrs: {
                title: "提醒",
                "close-on-click-modal": false,
                showcenter: "",
                visible: _vm.cancelDialog,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.cancelDialog = $event
                },
                close: function($event) {
                  _vm.cancelDialog = false
                }
              }
            },
            [
              _c(
                "span",
                [
                  _c("xui-icon", {
                    staticClass: "dialog_span-icon",
                    attrs: { icon: "fa fa-exclamation-triangle" }
                  }),
                  _vm._v(
                    "确定选择退出，系统将删除您在荣耀安全响应中心平台所有的个人数据。（若您是团队队长，建议您先将团队队长转让给其他团队成员，我们会在您退出奖励计划的同时将你所在的团队队长转让给其他团队成员，若当前团队仅有您自己时，团队将会解散）"
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("span", [_vm._v("是否确认退出？")]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: { click: _vm.logout }
                    },
                    [_vm._v("确定")]
                  ),
                  _vm._v(" "),
                  _c(
                    "xui-button",
                    {
                      attrs: { size: "bigger" },
                      on: { click: _vm.cancelDialogMethod }
                    },
                    [_vm._v("取消")]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isNotLogin && _vm.isEffect
        ? _c(
            "xui-dialog",
            {
              staticClass: "login-dialog",
              attrs: {
                title: "失效提醒",
                "close-on-click-modal": false,
                showcenter: "",
                visible: _vm.isNotLogin,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.isNotLogin = $event
                },
                close: _vm.handleClose
              }
            },
            [
              _c("span", [_vm._v("您的账号已经失效，请联系管理员")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: { click: _vm.handleClose }
                    },
                    [_vm._v("返回首页")]
                  )
                ],
                1
              )
            ]
          )
        : _c(
            "xui-dialog",
            {
              staticClass: "login-dialog",
              attrs: {
                title: "登录提醒",
                "close-on-click-modal": false,
                showcenter: "",
                visible: _vm.isNotLogin,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.isNotLogin = $event
                },
                close: _vm.handleClose
              }
            },
            [
              _c("span", [_vm._v("系统检测到您未登录或登录失效，请先登录")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: { click: _vm.login }
                    },
                    [_vm._v("荣耀账号登录")]
                  )
                ],
                1
              )
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61d4f81a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61d4f81a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/usercenter/info/usercenterInfo.vue
// module id = null
// module chunks = 